// resorts slider
$(function () {
    $(document).ready(function () {
        $('.slider-withtext-textslider').each(function () {
            let thisElement = $(this);
            thisElement.slick({
                fade: true,
                dots: true,
                appendDots: thisElement.find('.slider-withtext-title'),
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: thisElement.closest('.slider-withtext').find(
                    '.sliderPrevButton'),
                nextArrow: thisElement.closest('.slider-withtext').find(
                    '.sliderNextButton'),
                mobileFirst: true,
                asNavFor: thisElement.closest('.slider-withtext').find(
                    '.slider-withtext-imageslider'),
                draggable: false,
                swipe: false
            });

            thisElement.find(".slider-withtext-title").each(function (i) {
                var dotsList = $(this).find(`.slick-dots li`).eq(i).find("button");
                dotsList.css({
                    "background": "#104187",
                });
            });
        });

        $('.slider-withtext-imageslider').each(function () {
            let thisElement = $(this);
            thisElement.slick({
                fade: true,
                dots: false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: false,
                nextArrow: false,
                mobileFirst: true,
                draggable: false,
                swipe: false
            });
        });
    });
})
// resorts-card slider
$(function () {
    $(document).ready(function () {
        $(".resorts-slider-items").each(function () {
            let thisElement = $(this);
            thisElement.slick({
                fade: false,
                dots: false,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: false,
                nextArrow: false,
                mobileFirst: true,
                variableWidth: true,
                touchThreshold: 4000,
                responsive: [{
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                    }
                },
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                },
                ]
            });
        })
    });
});
// banner slider
$(function () {
    $(document).ready(function () {
        $(".banner-slider-items").each(function () {
            let thisElement = $(this);
            let parent = $(this).closest('.banner-slider');
            thisElement.slick({
                fade: true,
                dots: parent.hasClass('__dots'),
                appendDots: parent.hasClass('__dots') ? thisElement.find(
                    '.slideritem-title') : false,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: parent.hasClass('__arrows') ? thisElement.closest(
                    '.banner-slider').find('.sliderPrevButton') : false,
                nextArrow: parent.hasClass('__arrows') ? thisElement.closest(
                    '.banner-slider').find('.sliderNextButton') : false,
                mobileFirst: true,
                autoplay: true,
                autoplaySpeed: 3000,
                responsive: [{
                    breakpoint: 992,
                    settings: {
                        slidesToShow: 1
                    }
                },]
            });

            if (parent.hasClass('__dots')) {
                thisElement.find(".slideritem-title").each(function (i) {
                    var dotsList = $(this).find(`.slick-dots li`).eq(i).find(
                        "button");
                    dotsList.css({
                        "background": "transparent",
                        "width": "13px",
                        "height": "13px"
                    });
                });
            }
        })
    });
});
$(function () {
    $(document).ready(function () {
        $(".slider-items").each(function () {
            var thisElement = $(this);
            thisElement.slick({
                fade: true,
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: thisElement.closest('.slider').find('.sliderPrevButton'),
                nextArrow: thisElement.closest('.slider').find('.sliderNextButton'),
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 1
                        }
                    },
                ]
            });
        })
    });
});